// import axios from 'axios';

// const api = axios.create({
//   baseURL: 'http://localhost:5000',
//   timeout: 10000,
// });

// api.interceptors.request.use(
//   async (config) => {
//     const adminToken = localStorage.getItem('adminToken');
//     if (adminToken) {
//       config.headers['x-auth-token'] = adminToken;
//       config.headers['user-type'] = 'admin';
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     if (error.response?.status === 401) {
//       localStorage.removeItem('adminToken');
//     }
//     return Promise.reject(error);
//   }
// );

// export default api;

// utils/api.js - UPDATED WITH LONGER TIMEOUT
// utils/api.js - UPDATED
import axios from "axios";

const api = axios.create({
  baseURL: "https://kidsm.vercel.app",
  timeout: 300000, // 5 minutes for video uploads
});

api.interceptors.request.use(
  async (config) => {
    const adminToken = localStorage.getItem("adminToken");
    console.log(
      "API Request - Admin Token:",
      adminToken ? "Present" : "Missing"
    ); // Debug log

    if (adminToken) {
      config.headers["x-auth-token"] = adminToken;
      config.headers["user-type"] = "admin";
    }

    // For FormData (file uploads), don't set Content-Type
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
      console.log("FormData detected, Content-Type header removed"); // Debug log
    }

    console.log("Request Headers:", config.headers); // Debug log
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    console.log("API Response Success:", response.status); // Debug log
    return response;
  },
  async (error) => {
    console.log(
      "API Response Error:",
      error.response?.status,
      error.response?.data
    ); // Debug log

    if (error.response?.status === 401) {
      console.log("Unauthorized - removing admin token");
      localStorage.removeItem("adminToken");
      // You might want to redirect to login page here
      window.location.href = "/admin-login";
    }
    return Promise.reject(error);
  }
);

export default api;
